import React, { createContext, useState, useEffect } from "react";

export const SearchContext = createContext();

const SearchContextProvider = (props) => {
  const [state, setState] = useState({
    searchTerm: "",
    selection: null,
    history: [],
  });

  const [suggestionResults, setSuggestionResults] = useState(null);

  useEffect(() => {
    // console.log(state);
    // console.log(suggestionResults);
  }, [state, suggestionResults]);

  const value = { state, setState, suggestionResults, setSuggestionResults };

  return (
    <SearchContext.Provider value={value}>
      {props.children}
    </SearchContext.Provider>
  );
};

export default SearchContextProvider;
